import ErrorComponent from "@/components/atoms/ErrorComponent";
import PersonHeader from "@/components/molecules/card-headers/people/PersonHeader";
import PersonEditCard from "@/components/molecules/cards/person/PersonEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import Person from "@/interfaces/Person";
import { FC, useState } from "react";
import { useParams } from "react-router-dom";

const PersonEditView: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [person, setPerson] = useState<Person>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      {person && <PersonHeader id={id} companyId={person.companyId} isEdit />}
      <PersonEditCard id={id} callBack={setPerson} />
    </div>
  );
};

export default PersonEditView;
